import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Tooltip, Snackbar, Alert, CircularProgress } from '@mui/material';
import axios from '../utils/axiosConfig';

const ProjectDialog = ({ open, onClose, projectId, isNewProject }) => {
  const [projectName, setProjectName] = useState('');
  const [interviewGuide, setInterviewGuide] = useState('');
  const [introMessage, setIntroMessage] = useState('');
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open &&!isNewProject && projectId) {
      const fetchProject = async () => {
        try {
          const response = await axios.get(`/api/projects/${projectId}`);
          const project = response.data;
          setProjectName(project.project_name);
          setInterviewGuide(project.interview_guide);
          setIntroMessage(project.intro_message);
        } catch (error) {
          console.error('Failed to fetch project:', error);
        }
      };

      fetchProject();
    }
  }, [open, projectId, isNewProject]);

  const handleSave = async () => {
    setLoading(true);
    const projectData = {
      project_name: projectName,
      interview_guide: interviewGuide,
      intro_message: introMessage,
    };

    try {
      let response;
      if (isNewProject) {
        response = await axios.post('/api/projects', projectData);
        onClose(response.data.id); // Assuming the backend returns the new project ID
      } else {
        await axios.put(`/api/projects/${projectId}`, projectData);
        onClose();
      }
    } catch (error) {
      console.error('Failed to save project:', error);
      setErrorMessage('Failed to save project. Please try again.');
      setErrorOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseError = () => {
    setErrorOpen(false);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{isNewProject ? 'Create New Project' : 'Edit Project'}</DialogTitle>
        <DialogContent dividers style={{ maxHeight: '70vh', overflow: 'auto' }}>
          <Tooltip title="Enter the name of the project">
            <TextField
              label="Project Name"
              fullWidth
              margin="normal"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
            />
          </Tooltip>
          <Tooltip title="Enter the interview guidelines for the project">
            <TextField
              label="Interview Guidelines"
              fullWidth
              margin="normal"
              multiline
              maxRows={20}
              value={interviewGuide}
              onChange={(e) => setInterviewGuide(e.target.value)}
            />
          </Tooltip>
          <Tooltip title="Enter the introductory message for the project">
            <TextField
              label="Introductory Message"
              fullWidth
              margin="normal"
              multiline
              maxRows={10}
              value={introMessage}
              onChange={(e) => setIntroMessage(e.target.value)}
            />
          </Tooltip>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose()} color="primary" disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : (isNewProject ? 'Create' : 'Save')}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ProjectDialog;
